<!-- @format -->

<public-info-navi-modal>
  <!-- @format -->
  <style>
    .modal__content_inner {
      max-height: 80vh;
      overflow-y: auto;
    }
    .wp60 {
      width: 60%;
    }
    .modal-error {
      margin: 4px 0px 16px 60%;
    }
    p {
      font-size: 1.3rem;
      line-height: 1.8rem;
    }
    p.footnote {
      font-size: 1.15rem;
      line-height: 1.5rem;
    }
  </style>

  <div class="modal js-modal" is="modal-base" is-open="{ props.isOpen }">
    <div class="modal__bg js-modal-close" onclick="{ props.onClose }"></div>
    <div class="modal__content">
      <div class="modal__content_inner">
        <h3 class="modal_heading margin-spacing-3_bottom">
          【必ずご確認ください】公開情報が未記入の状態です
        </h3>
        <h4 class="heading-04 margin-spacing-2_top margin-spacing-2_bottom">
          プロフィール入力画面において、公開情報が未入力の状態です。
        </h4>
        <p>
          公開情報が未入力の場合、EDILENT for
          Client（クライアント用管理画面）の「編集者・ライター検索」機能において検索対象とならず、指名オファーを受けることもできません。
        </p>
        <p>ご入力をよろしくお願いいたします。</p>
        <p class="footnote margin-spacing-2_top">
          ※発注者の方は公開情報だけではなく、スキルシートや職歴・制作実績なども確認しています。すべて入力してプロフィールを充実させましょう。
        </p>
        <div class="wrap_button margin-spacing-2_top">
          <a
            class="button button-secondary-large"
            value="登録する"
            href="{ routes.makePath('public-info-tag') }"
          >
            公開情報・スキルシートを入力
          </a>
        </div>
      </div>
      <!--/.modal__content_inner-->
      <a class="btn_close_modal js-modal-close" onclick="{ props.onClose }"></a>
    </div>
    <!--modal__content-->
  </div>

  <script>
    import base from "../modal-base.riot";
    import routes from "@model/menu-routes.js";

    export default {
      components: {
        "modal-base": base,
      },
      onBeforeMount() {
        this.routes = routes;
      },
    };
  </script>
</public-info-navi-modal>
